<template>
  <div>
    <div :style="{display: !showDetails ? 'inherit' : 'none'}">
      <!--    <div v-if="!showDetails">-->
      <!--    gesamt-->
      <v-card class="mx-3 mb-3" ref="card">
        <v-card-title>
          Mein Leben
          <v-spacer/>
          <v-btn text fab small @click="onHelp">
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-2">
      <span v-if="!loading && numIndices <= 0">
        Du hast noch keine Indexwerte. Gib deine Aktivitäten ein, damit dein aktueller Wochenindex berechnet werden kann.
        Dieser Graph wird natürlich erst nach ein paar Wochen interessant.
      </span>
          <div v-else-if="loading">
            <v-progress-linear indeterminate></v-progress-linear>
          </div>
          <div v-else>
            <div class="body-1 d-flex justify-space-between">
              <span class="black--text">Gesamt <span class="ml-2 grey--text">⌀ {{ indexAvg }}</span></span>
              <span v-if="isFree">
              Zeitraum: Gesamt
            </span>
            <v-select v-else v-model="epoch" :items="epochs" class="mt-n4" style="max-width: 50%;"/>
            </div>
            <v-row class="">
              <line-chart :key="'idx'" ref="indexVueChart" :chartdata="indexChartData" :options="options" :height="120"
                          :width="chartWidth"/>
            </v-row>
            <div>
            <span class="mt-1 mr-1" style="font-size: 14px; font-weight: bold">
              — — — —
            </span>
              <span class="body-2"><small>Gesetztes Ziel (Indexwert von 100)</small></span>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <!--    wohlbefinden-->
      <v-card v-if="!loading && numIndices > 0" class="mx-3 mb-3">
        <v-card-title class="body-1 pb-0">
          <div class="body-1 d-flex justify-space-between">
            <span class="black--text">Wohlbefinden
              <span class="ml-2 grey--text">
                <v-icon class="mt-n1">{{ wohlbefindenIcon(wohlbefindenAvg) }}</v-icon>
              </span>
            </span>
          </div>
        </v-card-title>
        <v-card-text class="pb-1">
          <v-row class="">
            <line-chart key="wb" ref="wohlbefindenVueChart" :chartdata="wohlbefindenChartData"
                        :options="wohlbefindenOptions" :height="120" :width="chartWidth"/>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card v-if="!loading && numIndices > 0" class="mx-3 mb-3">
        <v-card-title class="body-1 pb-0">
          <div class="body-1 d-flex justify-space-between">
            <span class="black--text">Lebensbereiche im Vergleich</span>
          </div>
        </v-card-title>
        <v-card-text class="pb-1">
          <v-row class="mt-3">
            <line-chart :key="'idx'" ref="bVueChart" :chartdata="bChartData" :options="options" :height="120"
                        :width="chartWidth"/>
          </v-row>
        </v-card-text>
      </v-card>

      <!--    bereiche-->
      <v-card v-if="!loading && numIndices > 0" v-for="(b,i) in bereiche" class="mx-3 mb-3"
              @click="showDetailGraphs(b, i)">
        <v-card-title class="body-1 pb-0">
          {{ (b || {}).name }}
          <span class="ml-2 grey--text">⌀ {{ bereichAvg[i] }}</span>
        </v-card-title>
        <v-card-text class="pb-1">
          <div class="mt-3">
            <v-row class="">
              <line-chart :key="'b'+i" ref="bereichVueChart" :chartdata="bereichChartData[i]" :options="options"
                          :height="120"
                          :width="chartWidth"/>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <div :style="{display: showDetails ? 'inherit' : 'none'}">
      <!--    <div v-if="showDetails">-->
      <!-- details: bereich -->
      <v-row class="mx-3 mb-3">
        <v-btn @click="hideDetailGraphs">Übersicht</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="nextBereichDetailGraphs">{{ nextBereich.name }}</v-btn>
      </v-row>
      <v-card class="mx-3 mb-3">
        <v-card-title>
          Bereichsentwicklung
          <v-spacer/>
          <v-btn text fab small @click="onHelp">
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-2">
          <div>
            <div class="body-1 d-flex justify-space-between">
              <span class="black--text">{{ (detailBereich || {}).name }} <span
                  class="ml-2 grey--text">⌀ {{ bereichAvg[detailIndex] }}</span></span>
              <v-select v-model="epoch" :items="epochs" class="mt-n4" style="max-width: 50%;"/>
            </div>
            <v-row class="">
              <line-chart :key="'detail'+detailIndex" ref="detailBereichVueChart"
                          :chartdata="bereichChartData[detailIndex]" :options="options" :height="120"
                          :width="chartWidth"/>
            </v-row>
            <div>
            <span class="mt-1 mr-1" style="font-size: 14px; font-weight: bold">
              — — — —
            </span>
              <span>Gesetztes Ziel (Indexwert von 100)</span>
            </div>
          </div>
          <div v-if="loading">
            <v-progress-linear indeterminate></v-progress-linear>
          </div>
        </v-card-text>
      </v-card>

      <!--      activities-->
      <v-card v-if="!loadingActivitySums && activities.length > 0" v-for="(a,i) in bereichActivities" class="mx-3 mb-3">
        <v-card-title class="body-1 pb-0">
          {{ a.name }}
          <span class="ml-2 grey--text">⌀ {{ activityAvg(a) }}</span>
        </v-card-title>
        <v-card-text class="pb-1">
          <div class="mt-3">
            <v-row class="">
              <line-chart :key="a.id" ref="activityVueChart" :chartdata="activityChartData[a.id]" :options="options"
                          :height="120"
                          :width="chartWidth"/>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <div v-if="(isFree)" class="text-xl-center mb-3 ml-3 mr-1">
      <div class="mt-3 pa-3"
           style="border: 1px dashed dodgerblue; width: calc( 100% - 8px); height: 240px; border-radius: 5px; background-color: #ffffff30">
        <span class="headline">Verschiedene Zeiträume?</span>
        <br/><br/>
        Mit aimz <pro/> kannst du dir deine Leistungen im letzten Monat, Quartal, Haljahr oder Jahr ansehen.
        <br/><br/>
        <v-btn rounded class="d-flex mx-10 gelb dunkelblau--text" href="https://www.digistore24.com/product/410225"
               target="_blank">Upgrade auf aimz PRO</v-btn>
      </div>
    </div>

    <div class="d-flex">
      <v-btn class="mx-auto mt-3 mb-3" href="https://youtu.be/Gl4HA0YkZIw" target="_blank">
        <v-icon class="mr-2">mdi-play-box-outline</v-icon> Videoanleitung
      </v-btn>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import CenterContainer from "@/components/CenterContainer";
import Header1 from "@/components/Header1";
import Kinds from "@/components/Kinds";
import Medal from "@/components/Medal";
import LineChart from "@/components/Charts/LineChart";
import BEREICHE from "@/components/Bereiche";
import ActivityLibrary from "@/components/ActivityLibrary";
import {Ziele} from "@/components/Ziele";
import Pro from "@/components/Pro";


const {DateTime} = require("luxon");

const ALL = "Gesamt";
const THIS_YEAR = "Dieses Jahr";
const LAST_YEAR = "Letztes Jahr";
const THIS_QUARTER = "Dieses Quartal";
const LAST_QUARTER = "Letztes Quartal";
const THIS_MONTH = "Dieses Monat";
const LAST_MONTH = "Letztes Monat";

export default {
  name: 'IndexEntwicklung',
  components: {Medal, CenterContainer, Header1, LineChart, Pro},
  data: () => ({
    indices: [],
    activities: [],
    activitySums: [],
    targets: {},
    ziele:undefined,
    loading: false,
    loadingActivitySums: false,
    epochs: [ALL, THIS_YEAR, LAST_YEAR, THIS_QUARTER, LAST_QUARTER, THIS_MONTH, LAST_MONTH],
    epoch: ALL,

    showDetails: false,
    detailBereich: undefined,
    detailIndex: 0,
    detailBereichChart: undefined,

    indexChart: undefined,
    indexChartData: {},
    bChart: undefined,
    bChartData: {},
    wohlbefindenChart: undefined,
    wohlbefindenChartData: {},

    bereichCharts: [],
    bereichChartData: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],

    activityCharts: [],
    activityChartData: {},

    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            display: false,
          }
        }],
        yAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            display: false,
            min: 0,
            max: 200,
          },
        }]
      },
      layout: {
        padding: {
          top: 5,
          right: 5,
        }
      },
      tooltips: {
        enabled: false
      }
    },
    wohlbefindenOptions: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            display: false,
          }
        }],
        yAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            display: false,
            min: -2,
            max: 2,
          },
        }]
      },
      layout: {
        padding: {
          top: 5,
          right: 5,
        }
      },
      tooltips: {
        enabled: false
      }
    },
    chartWidth: 364,
  }),
  mounted() {
    this.load();
    var cardW = this.$refs.card.$el.clientWidth;
    this.chartWidth = cardW - 12;
    //console.log(cardW, this.chartWidth);
  },
  methods: {
    async load() {
      this.loading = true;
      this.indices = await this.$backend.get_all_objects(Kinds.KIND_INDEX) || [];
      for (const chart of Object.values(window.Chart.instances)) {
        window.Chart.animationService.cancelAnimation(chart);
      }
      this.$nextTick(() => this.updateCharts());
      this.loading = false;
      this.loadingActivitySums = true;
      //this.targets = (await this.$backend.get_object(Kinds.KIND_ZIELE, Ziele.makeId(this.dateTime.year)) || {});
      //this.ziele = new Ziele(this.targets);
      this.activities = ((await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY)) || []).filter(x => !x.deleted);
      this.activities.forEach(x => this.activityChartData[x.id] = {});
      this.activitySums = await this.$backend.get_activity_sums_with_targets() || [];
      if (this.showDetails) {
        for (const chart of Object.values(window.Chart.instances)) {
          window.Chart.animationService.cancelAnimation(chart);
        }
        this.updateActivityCharts();
        this.$nextTick(() => this.updateCharts());
      }
      this.loadingActivitySums = false;
    },
    updateCharts() {
      // INDEX
      if (this.$refs.indexVueChart && this.$refs.indexVueChart._data)
        this.indexChart = this.$refs.indexVueChart._data._chart;
      var values = this.indexValues;
      var labels = [...(values ?? []).map(x => x.date)];
      this.indexChartData.labels = labels;
      this.indexChartData.datasets = this.getDatasets(values, '#ffca37');
      if (!this.showDetails && this.indexChart)
        this.indexChart.update();
      // B (alle Bereiche in einem Chart)
      if (this.$refs.bVueChart && this.$refs.bVueChart._data)
        this.bChart = this.$refs.bVueChart._data._chart;
      this.bChartData.labels = labels;
      this.bChartData.datasets = this.getB_Datasets();
      if (!this.showDetails && this.bChart)
        this.bChart.update();
      // WOHLBEFINDEN
      if (this.$refs.wohlbefindenVueChart && this.$refs.wohlbefindenVueChart._data)
        this.wohlbefindenChart = this.$refs.wohlbefindenVueChart._data._chart;
      values = this.wohlbefindenValues;
      this.wohlbefindenChartData.labels = labels;
      this.wohlbefindenChartData.datasets = this.getWohlbefindenDatasets(values, '#42a5f5');
      if (!this.showDetails && this.wohlbefindenChart)
        this.wohlbefindenChart.update();
      // BEREICHE
      this.bereiche.forEach((b, i) => {
        if (this.$refs.bereichVueChart && this.$refs.bereichVueChart[i] && this.$refs.bereichVueChart[i]._data)
          this.bereichCharts[i] = this.$refs.bereichVueChart[i]._data._chart;
        this.bereichChartData[i].labels = [...labels];
        this.bereichChartData[i].datasets = this.getDatasets(this.bereichValues[i], BEREICHE.COLORS_BY_NAME[b.bid]);
        if (!this.showDetails && this.bereichCharts[i])
          this.bereichCharts[i].update();
      })
      // DETAILS
      //var i = this.detailIndex;
      if (this.$refs.detailBereichVueChart && this.$refs.detailBereichVueChart._data)
        this.detailBereichChart = this.$refs.detailBereichVueChart._data._chart;
      // this.bereichChartData[i].labels = [...labels];
      // this.bereichChartData[i].datasets = this.getDatasets(this.bereichValues[i], BEREICHE.COLORS[i]);
      if (this.showDetails && this.detailBereichChart)
        this.detailBereichChart.update();
      this.bereichActivities.forEach((a, i) => {
        if (this.$refs.activityVueChart && this.$refs.activityVueChart[i] && this.$refs.activityVueChart[i]._data)
          this.activityCharts[i] = this.$refs.activityVueChart[i]._data._chart;
        //this.bereichChartData[i].labels = [...labels];
        //this.bereichChartData[i].datasets = this.getDatasets(this.bereichValues[i], BEREICHE.COLORS[i]);
        if (this.showDetails && this.activityCharts[i])
          this.activityCharts[i].update();
      })
    },
    getDatasets(rawValues, color) {
      var values=[...(rawValues ?? []).map(x=>isNaN(x) ? 0 : x)]
      var a = [];
      a.push({
        label: 'Index',
        borderColor: color,
        backgroundColor: color + "99",
        pointRadius: 0,
        pointBorderColor: color,
        pointBackgroundColor: 'white',
        pointBorderWidth: 2,
        lineTension: 0,
        data: values,
        order: 2, // higher order is drawn first
      })
      a.push({
        label: 'Ziel',
        type: 'line',
        //backgroundColor: 'black',
        borderColor: 'black',
        data: [...values.map(x => 100)],
        lineTension: 0,
        fill: false,
        showLine: true,
        borderWidth: 1,
        pointRadius: 0,
        pointBorderWidth: 0,
        pointHitRadius: 0,
        pointHoverRadius: 0,
        borderDash: [10, 5],
        spanGaps: false,
        order: 1, // higher order is drawn first
      });
      return a;
    },
    getB_Datasets() {
      var a = [];
      var values = []
      this.bereiche.forEach((b, i) => {
        values = this.bereichValues[i];
        var color = BEREICHE.COLORS_BY_NAME[b.bid];
        a.push({
          label: b.name,
          borderColor: color,
          fill: false,
          //backgroundColor: color+"99",
          pointRadius: 0,
          pointBorderColor: color,
          pointBackgroundColor: 'white',
          pointBorderWidth: 2,
          lineTension: 0,
          data: values ?? [],
          order: 2, // higher order is drawn first
        })
      })
      a.push({
        label: 'Ziel',
        type: 'line',
        //backgroundColor: 'black',
        borderColor: 'black',
        data: [...(values ?? []).map(x => 100)],
        lineTension: 0,
        fill: false,
        showLine: true,
        borderWidth: 1,
        pointRadius: 0,
        pointBorderWidth: 0,
        pointHitRadius: 0,
        pointHoverRadius: 0,
        borderDash: [10, 5],
        spanGaps: false,
        order: 1, // higher order is drawn first
      });
      return a;
    },
    getWohlbefindenDatasets(values, color) {
      var a = [];
      a.push({
        label: 'Wohlbefinden',
        borderColor: color,
        backgroundColor: color + "99",
        pointRadius: 0,
        pointBorderColor: color,
        pointBackgroundColor: 'white',
        pointBorderWidth: 2,
        lineTension: 0,
        data: values ?? [],
        order: 2, // higher order is drawn first
      })
      a.push({
        label: 'Normal',
        type: 'line',
        //backgroundColor: 'black',
        borderColor: 'grey',
        data: [...(values ?? []).map(x => 0)],
        lineTension: 0,
        fill: false,
        showLine: true,
        borderWidth: 1,
        pointRadius: 0,
        pointBorderWidth: 0,
        pointHitRadius: 0,
        pointHoverRadius: 0,
        //borderDash: [10, 5],
        spanGaps: false,
        order: 1, // higher order is drawn first
      });
      return a;
    },
    onHelp() {
      this.$events.$emit("ask", {
        title: 'Index-Entwicklung', yes_button: 'OK',
        question: 'Hier wird die Entwicklung deines Wochen-Index und damit deine Erfolgskurve über die Zeit dargestellt.<br>' +
            'Klicke auf die Bereiche für Detailgraphen zu deinen Aktivitäten.',
      });
    },
    wohlbefindenIcon(happyness) {
      console.log({happyness});
      if (happyness >= 2)
        return 'mdi-emoticon-outline';
      if (happyness >= 1)
        return 'mdi-emoticon-happy-outline';
      if (happyness >= 0)
        return 'mdi-emoticon-neutral-outline';
      if (happyness >= -1)
        return 'mdi-emoticon-sad-outline';
      if (happyness < -1)
        return 'mdi-emoticon-cry-outline';
      return 'mdi-emoticon-neutral-outline';
    },
    showDetailGraphs(bereich, i) {
      for (const chart of Object.values(window.Chart.instances)) {
        window.Chart.animationService.cancelAnimation(chart);
      }
      this.showDetails = true;
      this.detailBereich = bereich;
      this.detailIndex = i;
      this.updateActivityCharts();
      this.$nextTick(() => this.updateCharts());
    },
    hideDetailGraphs() {
      for (const chart of Object.values(window.Chart.instances)) {
        window.Chart.animationService.cancelAnimation(chart);
      }
      this.showDetails = false;
      //this.k++;
      this.$nextTick(() => {
        this.updateCharts();
      });
    },
    nextBereichDetailGraphs() {
      var nextIndex = (this.detailIndex + 1) % this.bereiche.length;
      var nextBereich = this.bereiche[nextIndex];
      this.showDetailGraphs(nextBereich, nextIndex);
    },
    deNaN(x) {
      if (isNaN(x) || x===undefined || x===null)
        return 0;
      return x;
    },
    updateActivityChartData(a) {
      var target = this.weekTarget(a);
      var values = this.activitySumsOfEpoch.map(x => this.deNaN((x[a.id] || 0) / this.cleanTarget((x.ziele || {})[a.id] || target) * 100));
      var labels = this.activitySumsOfEpoch.map(x => x.id);
      var datasets = this.getDatasets(values, BEREICHE.COLORS_BY_NAME[this.detailBereich.bid]);
      this.activityChartData[a.id].labels = labels;
      this.activityChartData[a.id].datasets = datasets;
    },
    activityAvg(a) {
      var values = this.trimLeadingZeros(this.activitySumsOfEpoch.filter(x => !(x.pause)).map(x => this.deNaN(x[a.id] || 0)));
      var n = values.length;
      if (n === 0)
        return 0;
      return Math.round(values.reduce((a, b) => a + b, 0) / n);
    },
    updateActivityCharts() {
      if (!this.showDetails)
        return;
      this.activities.forEach(x => this.updateActivityChartData(x));
    },
    weekTarget(a) {
      if (a.type === ActivityLibrary.TYPE_BOOL) {
        if (a.freq === ActivityLibrary.FREQ_DAILY)
          return 7;
        return this.cleanTarget(a.target);
      }
      if (a.freq === ActivityLibrary.FREQ_DAILY)
        return 7 * this.cleanTarget(a.target);
      return this.cleanTarget(a.target);
    },
    cleanTarget(x) {
      if (x===undefined || x===null || isNaN(x))
        return 1;
      if (typeof x === 'string')
        return parseInt(x);
      return x;
    },
    trimLeadingZeros(a){
      while (a[0] === 0) {
        a.shift()
      }
      return a;
    },
  },
  computed: {
    isFree() {
      return this.$app.isFree;
    },
    isSilver() {
      return this.$app.isSilver;
    },
    isGold() {
      return this.$app.isGold;
    },
    app() {
      return this.$app;
    },
    numIndices() {
      return this.indices.length;
    },
    indicesOfEpoch() {
      var date = DateTime.local();
      var year = date.toISODate().substring(0, 4);
      var lastYear = date.minus({years: 1}).toISODate().substring(0, 4);
      switch (this.epoch) {
        case THIS_YEAR:
          return this.indices.filter(x => x.date.startsWith(year));
        case LAST_YEAR:
          return this.indices.filter(x => x.date.startsWith(lastYear));
        case THIS_QUARTER:
          var month = new Date(Date.now()).getMonth();
          var q = Math.floor(month / 3) + 1;
          console.log("filtering THIS_QUARTER " + q);
          switch (q) {
            case 1:
              return this.indices.filter(x => x.date.startsWith(year + "-01") || x.date.startsWith(year + "-02") || x.date.startsWith(year + "-03"));
            case 2:
              return this.indices.filter(x => x.date.startsWith(year + "-04") || x.date.startsWith(year + "-05") || x.date.startsWith(year + "-06"));
            case 3:
              return this.indices.filter(x => x.date.startsWith(year + "-07") || x.date.startsWith(year + "-08") || x.date.startsWith(year + "-09"));
            case 4:
              return this.indices.filter(x => x.date.startsWith(year + "-10") || x.date.startsWith(year + "-11") || x.date.startsWith(year + "-12"));
          }
          break;
        case LAST_QUARTER:
          var month = new Date(Date.now()).getMonth();
          var q = Math.floor(month / 3) + 0; // <-- last quarter!
          console.log("filtering LAST_QUARTER " + q);
          switch (q) {
            case 0:
              return this.indices.filter(x => x.date.startsWith(lastYear + "-10") || x.date.startsWith(lastYear + "-11") || x.date.startsWith(lastYear + "-12"));
            case 1:
              return this.indices.filter(x => x.date.startsWith(year + "-01") || x.date.startsWith(year + "-02") || x.date.startsWith(year + "-03"));
            case 2:
              return this.indices.filter(x => x.date.startsWith(year + "-04") || x.date.startsWith(year + "-05") || x.date.startsWith(year + "-06"));
            case 3:
              return this.indices.filter(x => x.date.startsWith(year + "-07") || x.date.startsWith(year + "-08") || x.date.startsWith(year + "-09"));
          }
          break;
        case THIS_MONTH:
          var mon = date.toISODate().substring(0, 7);
          console.log("filtering THIS_MONTH " + mon);
          return this.indices.filter(x => x.date.startsWith(mon));
        case LAST_MONTH:
          var mon = date.minus({months: 1}).toISODate().substring(0, 7);
          console.log("filtering LAST_MONTH " + mon);
          return this.indices.filter(x => x.date.startsWith(mon));
      }
      return this.indices;
    },
    activitySumsOfEpoch() {
      var date = DateTime.local();
      var year = date.toISODate().substring(0, 4);
      var lastYear = date.minus({years: 1}).toISODate().substring(0, 4);
      switch (this.epoch) {
        case THIS_YEAR:
          return this.activitySums.filter(x => x.id.startsWith(year));
        case LAST_YEAR:
          return this.activitySums.filter(x => x.id.startsWith(lastYear));
        case THIS_QUARTER:
          var month = new Date(Date.now()).getMonth();
          var q = Math.floor(month / 3) + 1;
          console.log("filtering THIS_QUARTER " + q);
          switch (q) {
            case 1:
              return this.activitySums.filter(x => x.id.startsWith(year + "-01") || x.id.startsWith(year + "-02") || x.id.startsWith(year + "-03"));
            case 2:
              return this.activitySums.filter(x => x.id.startsWith(year + "-04") || x.id.startsWith(year + "-05") || x.id.startsWith(year + "-06"));
            case 3:
              return this.activitySums.filter(x => x.id.startsWith(year + "-07") || x.id.startsWith(year + "-08") || x.id.startsWith(year + "-09"));
            case 4:
              return this.activitySums.filter(x => x.id.startsWith(year + "-10") || x.id.startsWith(year + "-11") || x.id.startsWith(year + "-12"));
          }
          break;
        case LAST_QUARTER:
          var month = new Date(Date.now()).getMonth();
          var q = Math.floor(month / 3) + 0; // <-- last quarter!
          console.log("filtering LAST_QUARTER " + q);
          switch (q) {
            case 0:
              return this.activitySums.filter(x => x.id.startsWith(lastYear + "-10") || x.id.startsWith(lastYear + "-11") || x.id.startsWith(lastYear + "-12"));
            case 1:
              return this.activitySums.filter(x => x.id.startsWith(year + "-01") || x.id.startsWith(year + "-02") || x.id.startsWith(year + "-03"));
            case 2:
              return this.activitySums.filter(x => x.id.startsWith(year + "-04") || x.id.startsWith(year + "-05") || x.id.startsWith(year + "-06"));
            case 3:
              return this.activitySums.filter(x => x.id.startsWith(year + "-07") || x.id.startsWith(year + "-08") || x.id.startsWith(year + "-09"));
          }
          break;
        case THIS_MONTH:
          var mon = date.toISODate().substring(0, 7);
          console.log("filtering THIS_MONTH " + mon);
          return this.activitySums.filter(x => x.id.startsWith(mon));
        case LAST_MONTH:
          var mon = date.minus({months: 1}).toISODate().substring(0, 7);
          console.log("filtering LAST_MONTH " + mon);
          return this.activitySums.filter(x => x.id.startsWith(mon));
      }
      return this.activitySums;
    },
    indexValues() {
      return this.indicesOfEpoch.map(x => this.deNaN(x.index || 0));
    },
    indexValuesOhnePause() {
      return this.trimLeadingZeros(this.indicesOfEpoch.filter(x => !(x.pause)).map(x => x.index || 0));
    },
    wohlbefindenValues() {
      return this.indicesOfEpoch.map(x => this.deNaN(x.happyness || 0));
    },
    wohlbefindenValuesOhnePause() {
      return this.indicesOfEpoch.filter(x => !(x.pause)).map(x => this.deNaN(x.happyness || 0));
    },
    bereichValues() {
      var a = [];
      this.bereiche.forEach(b => {
        a.push(this.indicesOfEpoch.map(x => this.deNaN(x[b.bid] || 0)));
      });
      return a;
    },
    bereichValuesOhnePause() {
      var a = [];
      this.bereiche.forEach(b => {
        a.push(this.trimLeadingZeros(this.indicesOfEpoch.filter(x => !(x.pause)).map(x => this.deNaN(x[b.bid] || 0))));
      });
      return a;
    },
    indexAvg() {
      var n = this.indexValuesOhnePause.length;
      if (n == 0)
        return 0;
      return Math.round(this.indexValuesOhnePause.reduce((a, b) => a + b, 0) / n);
    },
    wohlbefindenAvg() {
      var n = this.wohlbefindenValuesOhnePause.length;
      if (n == 0)
        return 0;
      return Math.round(this.wohlbefindenValuesOhnePause.reduce((a, b) => a + b, 0) / n);
    },
    bereichAvg() {
      var n = this.indexValuesOhnePause.length;
      if (n == 0)
        return 0;
      var avg = [];
      this.bereiche.forEach((b, i) => {
        var a=this.bereichValuesOhnePause[i];
        avg.push((a.length==0) ? 0 : Math.round(a.reduce((a, b) => a + b, 0) / a.length));
      });
      return avg;
    },
    bereiche() {
      return this.$app.bereiche;
    },
    bereichActivities() {
      if (!this.detailBereich)
        return [];
      return this.activities.filter(x => x.name && x.bereich === this.detailBereich.bid);
    },
    nextBereich() {
      var nextIndex = (this.detailIndex + 1) % this.bereiche.length;
      return this.bereiche[nextIndex];
    }
  },
  watch: {
    epoch() {
      this.updateActivityCharts();
      this.$nextTick(() => this.updateCharts());
    }
    // is_logged_in(n, o) {
    //     console.log("is_logged_in: " + n);
    //     if (!n) {
    //         this.$router.go(-1000);
    //         this.$router.replace("/")
    //     }
    // }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>